import { FormControlBase } from './form-control-base';

export class PasswordControl extends FormControlBase<string> {
    public controlType: string = 'password';
    public placeHolder: string = '';
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/password-control.ts